module.exports = __webpack_public_path__ + "img/palm2_11.ece820cd.png";